import React, { lazy } from 'react';
import styled from 'styled-components';

import {
  Box as MuiBox,
  Typography as MuiTypography,
  useTheme,
} from '@mui/material';

import { cutDownText } from 'lib/utils';
import setColors from 'lib/utils/setColors';
import { getMainComponent } from 'lib/utils/metricComponents';

const MetricChip = styled(({ state, onClick, ...props }) => {
  const theme = useTheme();
  const mainComponent = getMainComponent(state?.components);
  const scoreInfo = setColors(
    mainComponent?.score,
    theme,
    mainComponent?.scoreType || 'RISK'
  );
  var color = scoreInfo.background;

  return (
    <MuiBox
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        padding: '8px',
        width: '110px',
        cursor: onClick ? 'pointer' : 'default',
        background: color,
      }}
      onClick={onClick}
    >
      <MuiBox display="flex" flexDirection="column" width="100%">
        <MuiTypography
          sx={{ fontSize: 10, fontWeight: 600, textTransform: 'capitalize' }}
        >
          {cutDownText({
            text: state?.title,
            symbolsQtty: 14,
          })}
        </MuiTypography>
        {/* Display score type interpretation text */}
        {mainComponent?.score != null && (
          <MuiTypography
            sx={{
              fontSize: 8,
              fontWeight: 500,
              color: scoreInfo.color,
              marginTop: '2px'
            }}
          >
            {cutDownText({
              text: scoreInfo.text,
              symbolsQtty: 12,
            })}
          </MuiTypography>
        )}
      </MuiBox>
      {mainComponent?.quantityValue?.value != null && (
        <MuiBox display="flex">
          <MuiTypography sx={{ fontSize: 13, fontWeight: 600 }}>
            {cutDownText({
              text: `${mainComponent?.quantityValue?.value}  ${
                mainComponent?.quantityValue?.unit || ''
              }`,
              symbolsQtty: 6,
            })}
          </MuiTypography>
        </MuiBox>
      )}
    </MuiBox>
  );
})`
  && {
    color: ${({ theme }) => theme.palette.colors.black100};
    border-radius: 6px;
    border-color: ${({ theme }) => theme.palette.colors.gray100};
    margin: 4px;
    min-width: 80px;
    min-height: 48px;
  }
`;

export default React.memo(MetricChip);
